$(document).on('click', '[data-tncp-elementtoggler-trigger]', function () {

    let $trigger = $(this);
    let identifier = $trigger.data('tncpElementtogglerFor');
    let target = $trigger.data('tncpElementtogglerTrigger');

    $(document).find('[data-tncp-elementtoggler-for="' + identifier + '"][data-tncp-elementtoggler-target]').hide();
    $(document).find('[data-tncp-elementtoggler-for="' + identifier + '"][data-tncp-elementtoggler-target="' + target + '"]').show();

});
